import { translations as translationsEn } from './en'
import { translations as translationsCn } from './cn'
import * as _ from 'lodash'

const metaldeskTranslations = {
  en: translationsEn,
  cn: translationsCn
}

function getTranslations(language: string) {
  return _.defaultsDeep(metaldeskTranslations[language], metaldeskTranslations['en'])
}

export default getTranslations



// WEBPACK FOOTER //
// ./react/translations/index.ts